import Modal from "antd/es/modal/Modal";
import i18next from "i18next";
import {Divider, Form, Input} from "antd";
import React from "react";
import TextArea from "antd/es/input/TextArea";

const MapConfigModal = ({showModal, setShowModal, editMapConfig}) => {

    const handleOk = () => {
        setShowModal(false);
    };
    const handleCancel = () => {
        setShowModal(false);
    };

    return (
        <>
            <Modal title="Map Configuration" open={showModal} onOk={handleOk} onCancel={handleCancel} width={'60%'}>

                <br/>

                    <Form.Item
                        labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}
                        label={i18next.t('common.tools.edit.map.longitude')}
                        name="longitude"
                        initialValue={editMapConfig.map.mapConfig.center.longitude}
                        rules={[
                            {
                                required: true,
                                message: i18next.t('common.tools.edit.validation-msgs.required'),
                            },
                        ]}>
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}
                        label={i18next.t('common.tools.edit.map.latitude')}
                        name="latitude"
                        initialValue={editMapConfig.map.mapConfig.center.latitude}
                        rules={[
                            {
                                required: true,
                                message: i18next.t('common.tools.edit.validation-msgs.required'),
                            },
                        ]}>
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}
                        label={i18next.t('common.tools.edit.map.scale')}
                        name="scale"
                        initialValue={editMapConfig.map.mapConfig.scale}
                        rules={[
                            {
                                required: true,
                                message: i18next.t('common.tools.edit.validation-msgs.required'),
                            },
                        ]}>
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}
                        label={i18next.t('common.tools.edit.map.maxScale')}
                        name="maxScale"
                        initialValue={editMapConfig.map.mapConfig.maxScale}
                        rules={[
                            {
                                required: true,
                                message: i18next.t('common.tools.edit.validation-msgs.required'),
                            },
                        ]}>
                        <Input/>
                    </Form.Item>

                    <Divider />
                    <p style={{marginLeft: '40%'}}>Base Map</p>
                    <Form.Item
                        labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}
                        label={i18next.t('common.tools.edit.map.url')}
                        name="url"
                        initialValue={editMapConfig.map.mapConfig.baseMap.url}
                        rules={[
                            {
                                required: true,
                                message: i18next.t('common.tools.edit.validation-msgs.required'),
                            },
                        ]}>
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}
                        label={i18next.t('common.tools.edit.map.serviceMode')}
                        name="serviceMode"
                        initialValue={editMapConfig.map.mapConfig.baseMap.serviceMode}
                        rules={[
                            {
                                required: true,
                                message: i18next.t('common.tools.edit.validation-msgs.required'),
                            },
                        ]}>
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}
                        label={i18next.t('common.tools.edit.map.activeLayerId')}
                        name="activeLayerId"
                        initialValue={editMapConfig.map.mapConfig.baseMap.activeLayerId}
                        rules={[
                            {
                                required: true,
                                message: i18next.t('common.tools.edit.validation-msgs.required'),
                            },
                        ]}>
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}
                        label={i18next.t('common.tools.edit.map.activeLayerTileMatrix')}
                        name="activeLayerTileMatrix"
                        initialValue={editMapConfig.map.mapConfig.baseMap.activeLayerTileMatrix}
                        rules={[
                            {
                                required: true,
                                message: i18next.t('common.tools.edit.validation-msgs.required'),
                            },
                        ]}>
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}
                        label={i18next.t('common.tools.edit.map.thumbnailUrl')}
                        name="thumbnailUrl"
                        initialValue={editMapConfig.map.mapConfig.baseMap.thumbnailUrl}
                        rules={[
                            {
                                required: true,
                                message: i18next.t('common.tools.edit.validation-msgs.required'),
                            },
                        ]}>
                        <TextArea rows={4}/>
                    </Form.Item>

            </Modal>
        </>
    )
}
export default MapConfigModal;